export default {
  showPhysicians: true,
  allowPhysicianRegistration: true,
  showRealtors: false,
  allowAIJobSearch: true,
  posthogProjectToken: 'phc_wPDRNNUM9yn5EPjtpNpnNtHHjzZYxDHZyFREeEZHWP9d',
  posthogHost: 'https://us.i.posthog.com',
  posthogEnableSessionReplay: true,
}
